import { render, staticRenderFns } from "./SmallSpinner.vue?vue&type=template&id=0c5ca371&scoped=true&"
import script from "./SmallSpinner.vue?vue&type=script&lang=js&"
export * from "./SmallSpinner.vue?vue&type=script&lang=js&"
import style0 from "./SmallSpinner.vue?vue&type=style&index=0&id=0c5ca371&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ca371",
  null
  
)

export default component.exports